export default theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: 16,
    '& > [class*="isFullWidth"]': {
      gridColumn: '1 / span 2'
    }
  }
});